import { css, Global } from "@emotion/react";

const globalStyles = css`
  .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
    -webkit-text-fill-color: black !important;
  }
  .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 6.5px 8px !important;
  }
`;

const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
};

export default SC;
